<template>
  <div class="container-xl">
    <div class="card col-lg-12">
      <div class="card-header justify-content-between">
        <div class="card-title">AWA Request List</div><i class="el-icon-refresh" @click="getList()"></i>
      </div>
      <div class="card-body">
        <div class="flex">
          <div class="w-1/2">
            <el-form ref="form" label-width="120px">
              <el-form-item label="Request Date" v-if="!$route.params.status">
                <el-date-picker
                  v-model="search.date"
                  type="daterange"
                  size="small"
                  :picker-options="datePickerOptions"
                  class="w-full"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="Search Keyword">
                <el-input clearable size="small" type="text" v-model="search.search_keyword" placeholder="Input search keyword" class="mr-2"/>
              </el-form-item>
              <el-form-item label="Filter Type">
                <el-select size="small" v-model="search.search_by" class="mr-2">
                  <el-option v-for="(item, index) in search_options" :key="index" :value="item.value" :label="item.text"/>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="w-1/2">
            <el-form ref="form" label-width="120px">
              <el-form-item label="Bank Name ">
                  <el-select multiple filterable v-model="form.bank_id" placeholder="Select bank"  size="small"  class="mr-2">
                    <el-option value="" label="All">All</el-option>
                    <el-option v-for="(item) in bank_list" :key="item.code" :label="item.name" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
            </el-form>
          </div>
          <div class="ml-4 w-1/2" v-if="!$route.params.status">
            <el-form ref="form" label-width="150px">
              <el-form-item label="Approval Status">
                <el-select size="small" v-model="status_filter" placeholder="Approval Status" class="mr-2">
                  <el-option label="All" value=""/>
                  <el-option label="Waiting Approval" value="WAITING_APPROVAL"/>
                  <el-option label="Approved" value="approved"/>
                  <el-option label="Rejected" value="rejected"/>
                </el-select>
              </el-form-item>
              <el-form-item label="Disbursement Status">
                <el-select size="small" v-model="disbursement_status_filter" placeholder="Disbursement Status" class="mr-2">
                  <el-option label="All" value=""/>
                  <el-option label="Waiting Approval" value="WAITING_APPROVAL"/>
                  <el-option label="Waiting Disbursement" value="WAITING_DISBURSMENT"/>
                  <el-option label="Completed" value="completed"/>
                  <el-option label="Failed" value="failed"/>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-button type="primary" @click="searchHandler" size="small"><font-awesome-icon icon="search"/> Search</el-button>
        <el-button type="primary" @click="downloadHandler" size="small"><font-awesome-icon icon="download"/> Download</el-button>
        <!-- <el-button type="primary" @click="handlerApproveBtnn" size="small"> Approve All</el-button> -->
      </div>
      <div class="table-responsive">
        <el-skeleton :loading="is_loading" :rows="6" animated />
        <table v-if="!is_loading" class="table card-table text-nowrap table-vcenter">
          <thead>
            <tr>
              <th width="30%">Request Date</th>
              <th width="43%">Bank Account Name</th>
              <th width="40%">Name Verification</th>
              <th width="40%">Bank Account Number</th>
              <th width="40%">Bank ID</th>
              <th width="30%">Requestor Name</th>
              <th>Processing Fee</th>
              <th>Amount</th>
              <th>Admin Fee</th>
              <th>HR Approval Status</th>
              <th>HR Approval Date</th>
              <th>Disbursement Status</th>
              <th>Reference Number</th>
              <th>Disbursement Date</th>
              <th>Detail</th> 
              <th v-if="$route.params.status && $route.params.status != 'completed'">#</th> 
            </tr>
          </thead>
          <tbody v-loading="is_loading">
            <tr v-for="(item, i) in list" :key="i">
              <td>{{ item.created_at_str }}</td>
              <td>{{ item.bank_account_name != null ? item.bank_account_name : item.requestor?.full_name }}</td>
              <td><span class="tag">{{ compareNames(item.bank_account_name, item.requestor_name) ? 'Match' : 'Not match' }}</span></td>
              <td>{{ item.bank_account_number != null ? item.bank_account_number : item.requestor?.phone_number }}</td>
              <td>
                {{ item.bank_id != null ? item.bank_id : (item?.bank_code === "999" ? 'Dipay' : '') }}
              </td>
              <td>{{ item.requestor_name }}</td>
              <td>{{ item.processing_fee_str }}</td>
              <td>{{ item.request_amount_str }}</td>
              <td>{{ item.admin_fee_str }}</td>
              <td>
                <span class="tag" :class="item.status_color">{{ item.status_str }}</span>
              </td>
              <td>{{ item.approved_at_str }}</td>
              <td>
                <el-popover v-if="item.disburse_status == 'failed' && item.failed_reason"
                    placement="left"
                    width="300"
                    trigger="hover"
                    :content="item.failed_reason">
                      <span slot="reference" class="tag" :class="item.disburse_status_color">{{ item.disburse_status_str }}</span>
                  </el-popover>
                <span v-else class="tag" :class="item.disburse_status_color">{{ item.disburse_status_str }}</span>
              </td>
              <td>{{ item.reference_number || '-' }}</td>
              <td>{{ item.disburse_at_str }}</td>
              <td class="text-nowrap text-muted child1-sticky">
                <button @click="viewDetailTransaction(item)" title="View Detail" type="button"
                  class="btn btn-icon btn-flickr btn-sm"><font-awesome-icon icon="eye" /></button>
              </td>
              <td v-if="$route.params.status && $route.params.status != 'COMPLETED'">
                <el-button round size="mini" @click="handlerApproveBtn(item, $route.params.status)" type="success">
                  <font-awesome-icon icon="check"/> 
                </el-button>
                <el-button  v-if="form.bank_id && String(form.bank_id).trim() !== ''" round size="mini" @click="handlerApproveBtnn(item, $route.params.status)" type="success"> Approve All
                </el-button>
                <el-button v-if="$route.params.status == 'WAITING_APPROVAL'" round size="mini" @click="handlerBtnReject(item)" type="danger">
                  <font-awesome-icon icon="times-circle"/>
                </el-button>
                <el-button v-if="$route.params.status == 'WAITING_DISBURSEMENT'" round size="mini" @click="handlerBtnRollback(item)" type="danger">
                  <font-awesome-icon icon="undo-alt"/> 
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
        <el-empty description="No data found" v-if="!total_rows && !is_loading" :image="emptyStateImage"></el-empty>
      </div>
      <b-modal size="md" v-model="show.modal_ewa" title="Approve AWA" hide-footer>
        <el-descriptions :loading="loading.modal_ewa" class="margin-top" title="" :column="1" border>
          <!-- <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              Employee Name
            </template>
            {{ selected_ewa.requestor_name }}
          </el-descriptions-item> -->
          <el-descriptions-item>
            <template slot="label">
              <i><font-awesome-icon icon="users" size="sm"/></i>
              Total AWA Request
            </template>
             {{ selected_ewa_bank?.total_recipient }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i><font-awesome-icon icon="money-bill-alt" size="sm"/></i>
              Total AWA Amount
            </template>
             Rp. {{ formatCurrency(selected_ewa_bank?.total_amount) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i><font-awesome-icon icon="hand-holding-usd" size="sm"/></i>
              Total Admin Fee
            </template>
             Rp. {{ formatCurrency(selected_ewa_bank?.total_admin_fee) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i><font-awesome-icon icon="money-bill-wave" size="sm"/></i>
              Total Disburse Amount
            </template>
             Rp. {{ formatCurrency(selected_ewa_bank?.total_amount) }}
          </el-descriptions-item>
          <el-descriptions-item v-if="selected_ewa.current_state === 'WAITING_DISBURSEMENT'">
          <template slot="label">
            <i><font-awesome-icon icon="money-bill-wave" size="sm"/></i>
            Payment Confirmation Receipt
          </template>
          <b-form-file
            v-model="selected_file.payment_confirm_file"
            :state="Boolean(selected_file.payment_confirm_file)"
            class="mt-2 border-1 p-2"
            accept=".png, .jpg, .jpeg"
            @input="onChangeFile($event, 'payment_confirm_file')"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
            <img ref="payment_confirm_file" :src="test.payment_confirm_file"/>
        </el-descriptions-item>
        </el-descriptions>
        <div class="d-flex float-right mt-2">
         <div>
          <el-button v-if="!form.bank_id" class="mr-2 ml-2" @click="submit_approval" size="small" type="primary">Submit</el-button>
          <el-button v-else class="mr-2 ml-2" @click="submit_approval_all" size="small" type="primary">Submit</el-button>
          <el-button @click="show.modal_ewa = false" size="small" class="mr-2">Cancel</el-button>
         </div>
        </div>
      </b-modal>
      <pagination
        :page="page"
        :per_page="per_page"
        :list="list"
        :total_rows="total_rows"
        @pageChange="pageChangeHandler"
        />
      <b-modal size="xl" v-model="showDetailTransaction" :title="'Awa #' + selected_transaction.id" hide-footer>
        <el-skeleton :loading="loading_detail" :rows="6" animated />
        <el-descriptions v-if="!loading_detail" class="margin-top mb-3" title="AWA Information" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-date"></i>
              Transaction Date
            </template>
              {{ formatDate(selected_transaction.created_at) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-phone"></i>
              Disbursement Status
            </template>
            <span class="tag" :class="selected_transaction.disburse_status">{{ selected_transaction.disburse_status }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              User Name
            </template>
            {{ selected_transaction?.requestor?.full_name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-document"></i>
            Disbursement Date
            </template>
            {{ formatDate(selected_transaction.disburse_at) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-message"></i>
              Email
            </template>
            {{ selected_transaction?.requestor?.email }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-wallet"></i>
              Company Name
            </template>
            {{ selected_transaction.company_name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-finished"></i>
              Phone Number
            </template>
            {{ selected_transaction?.requestor?.phone_number }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-finished"></i>
              Processing Fee
            </template>
            {{`${  formatRupiah(selected_transaction?.processing_fee) || '0'}`  }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-finished"></i>
              Insurance Fee
            </template>
            {{`${  formatRupiah(selected_transaction?.insurance_fee) || '0'}`  }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="table-responsive">
          <table v-if="!loading_detail" class="table table-vcenter w-full">
            <thead>
              <tr>
                <th>Awa Request ID</th>
                <th>Installment Number</th>
                <th width="15%">Due date</th>
                <th>Amount</th>
                <th>Interest Amount</th>
                <th>Late Fee</th>
                <th>Total Amount</th>
                <th>Paid Amount</th>
                <th>Status</th>
                <th width="15%">Paid At</th>
              </tr> 
            </thead>
            <tbody>
              <tr v-for="inst in awa_list_detail.flatMap(awa => awa.installments)" :key="inst.id">
                <td>{{ inst.awa_request_id }}</td>
                <td>{{ inst.installment_number }}</td>
                <td>{{ formatDate(inst.due_date) }}</td>
                <td>{{ formatRupiah(inst?.amount) }}</td>
                <td>{{ formatRupiah(inst?.interest_amount) }}</td>
                <td>{{ formatRupiah(inst?.late_fee) }}</td>
                <td>{{ formatRupiah(inst?.total_amount) }}</td>
                <td>{{ formatRupiah(inst?.paid_amount) }}</td>
                <td>
                  <span class="tag" :class="inst.status_color">{{ inst.status_str }}</span>
                </td>
                <td>{{ formatDate(inst.paid_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import {
  GET_DETAIL_AWALIST_FINANCE, REJECT_AWA, ROLLBACK_APPROVAL, INQUIRY_APPROVAL, SUBMIT_APPROVAL,GET_DETAIL_AWA_INSTALLMENT
} from '@/store/modules/awa';
import emptyStateImage from '@/assets/images/undraw/empty-approval-history.svg';
import Pagination from '../../components/Pagination.vue';
import popupErrorMessages from '../../../library/popup-error-messages';
import imageCompress from '@/library/vue-image-compression';
import base64File from '@/library/base64File';
import {
  GET_BANK_LIST_CASHOUT
} from '@/store/modules/companies';

export default {
  components: { Pagination },
  name: 'DetailAwaCompany',
  data() {
    return {
      loading_detail: false,
      selected_transaction: {},
      showDetailTransaction: false,
      filter_by_options: [
        { value: 'status', text: 'HR Approval Status' },
        { value: 'disburse_status', text: 'Disbursement Status' },
      ],
      sort_by_options: [
        { value: 'created_at', text: 'Created At' },
        { value: 'updated_at', text: 'Updated At' },
        { value: 'disburse_at', text: 'Disburse At' },
      ],
      awa_list_detail: [],
      searchTriggered: false,
      bank_list: [],
      form: {
        bank_id: null
      },
       disburse: {
        approval_id: "",
        total_amount: 0,
        total_admin_fee: 0,
        auto_disburse: false,
        total_disburse_amount: 0
      },
      file_tmp: '',
      selected_file: {
          payment_confirm_file: null,  
          payment_confirm_file_base64: null,  
      },
      test: {
          payment_confirm_file: '',  
      },
      emptyStateImage,
      is_loading: false,
      total_rows: 0,
      page: 1,
      per_page: 20,
      list: [],
      show: {
        modal_ewa: false,
      },
      loading: {
        modal_ewa: false,
      },
      selected_ewa: {},
      selected_ewa_bank: {},
      status_filter: '',
      disbursement_status_filter: '',
      search: {
        search_keyword: '',
        search_by: 'full_name',
        date: [
          moment().subtract(1, 'month').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
        ],
        action: '',
      },
      search_options: [
        { value: 'full_name', text: 'Requestor Name' },
        { value: 'email', text: 'Requestor Email' },
        { value: 'phone_number', text: 'Requestor Phone Number' },
      ],
      datePickerOptions: {
        disabledDate: (date) => moment(date).isAfter(moment(), 'days'),
      },
    };
  },
  metaInfo: {
    title: 'Advanced Wage Access',
  },
  computed: {
    shouldDisplayPaymentReceiptForm() {
      return this.filter_value === 'WAITING_DISBURSEMENT' &&
            this.tab_options.some(tab => tab.value === 'WAITING_DISBURSEMENT');
    },
    showingFrom() {
      return this.total_rows ? ((this.page - 1) * this.per_page) + 1 : 0;
    },
    showingUntil() {
      if (this.total_rows) {
        if (this.list.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
    isRollbackVisible() {
      const status = this.$route.params.status;
      return ['WAITING_DISBURSEMENT'].includes(status);
    },
  },
  mounted() {
    this.getList();
    this.loadBankList();
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('DD MMM YYYY, HH:mm') : '-'
    },
    formatRupiah(value) {
      const num = Number(value) || 0;
      return `Rp.${num.toLocaleString()}`;
    },
    async viewDetailTransaction(item) { 
      this.selected_transaction = item;
      this.showDetailTransaction = true;
      try {
        const { data } = await this.$store.dispatch(GET_DETAIL_AWA_INSTALLMENT, {
          company_id: this.selected_transaction.company_id,
          id: this.selected_transaction.id,
        });
        const rows = data?.data?.rows ?? [];
        const installment_status = {
          WAITING_PAYMENT: { label: 'Waiting Payment', color: 'tag-warning' },
          WAITING_APPROVAL: { label: 'Waiting Approval', color: 'tag-warning' },
          PARTIAL_PAID: { label: 'Partial Paid', color: 'tag-info' },
          FULLY_PAID: { label: 'Paid', color: 'tag-success' },
          CANCELLED: { label: 'Cancelled', color: 'tag-danger' },
          REJECTED: { label: 'Rejected', color: 'tag-danger' },
        };
        this.awa_list_detail = rows.map((v) => {
          v.installments = (v.installments || []).map((inst) => {
            const status = installment_status[inst.status] || { label: '-', color: 'grey' };
            return {
              ...inst,
              status_str: status.label,
              status_color: status.color,
            };
          });
          return v;
        });
      } catch (e) {
        console.error("Failed", e);
      }
    },
    formatCurrency(value) {
        if (value === undefined || value === null) return '0'; 
        return value.toLocaleString();
    },
    async loadBankList() {
      await this.$store.dispatch(GET_BANK_LIST_CASHOUT, {
        limit: 200,
      }).then((data) => {
        this.bank_list = data.rows;
      }).catch((err) => {
        console.log(err);
        popupErrorMessages(err.response.data);
      });
    }, 
    async onChangeFile(event, target) {
      console.log('target ==>', target)
      if (this.selected_file[target]) {
        const compressed = await imageCompress(this.selected_file[target]);
        this.selected_file[`${target}_base64`] = await base64File(compressed);
        this.file_tmp = this.selected_file[`${target}_base64`]
      }
    },
    async downloadHandler() {
      try {
        this.isLoading = true;
          const headers = [
          "Request Date",
          "Bank Account Name",
          "Bank Account Number",
          "Bank ID",
          "Requestor Name",
          "Amount",
          "Admin Fee",
          "HR Approval Status",
          "Disbursement Status",
          "Reference Number",
          "Disbursement Date",
        ];
        const rows = this.list.map((item) => [
          item.created_at_str || "-",
          item.bank_account_name || "-",
          item.bank_account_number || "-",
          item.bank_id || "-",
          item.requestor_name || "-",
          item.request_amount_str || "0",
          item.admin_fee_str || "0",
          item.disburse_status_str || "-",
          item.status_str || "-",
          item.reference_number || "-",
          item.disburse_at_str || "-",
        ]);
        const csvContent = [
          headers.join(","),
          ...rows.map((r) => r.map((v) => `"${v}"`).join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        const dateFilter = Array.isArray(this.search.date_filter)
          ? this.search.date_filter.join("-")
          : "all";
        anchor.href = url;
        anchor.setAttribute("download", `AWA-Detail.csv`);
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
      } catch (err) {
      } finally {
        this.isLoading = false;
      }
    },
    compareNames(name1, name2) {
      if (!name1 || !name2) return false;
      const words1 = name1.toLowerCase().split(/\s+/);
      const words2 = name2.toLowerCase().split(/\s+/);
      return words1.some(w1 => words2.includes(w1));
    },
    async getList() {
      this.is_loading = true;
      this.$parent.showLoader();
      if (this.$route.params.status) {
        delete this.search.date;
      }
      const q = {
        filter_value: this.$route.params.status,
        filter_by: "status",
        page: this.page,
        // bank_code: JSON.stringify(this.form.bank_id || null),
        bank_code: (this.form.bank_id && this.form.bank_id.length)
          ? this.form.bank_id.join(',')   // 👉 "999,009"
          : null,
      };
      // if (q.disburse_status_filter === 'completed') {
      //   q.disburse_status_filter = ['completed', 'failed'];
      // }
      await this.$store.dispatch(GET_DETAIL_AWALIST_FINANCE, {
        id: this.$route.params.id,
        query: q,
      }).then((data) => {
        if (this.search.action === 'download') {
          const anchor = document.createElement('a');
          anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(data)}`;
          anchor.target = '_blank';
          anchor.download = 'AWA_Report.csv';
          anchor.click();
        }
      });
      this.$parent.hideLoader();
      if (this.search.action !== 'download') {
        const { rows, count } = this.$store.getters.detail_awa_list_finance;
        this.list = rows;
        this.total_rows = count;
      }
      this.is_loading = false;
    },
    pageChangeHandler(page) {
      this.page = page;
      this.getList();
    },
    searchHandler() {
      this.search.action = '';
      this.pageChangeHandler(1);
      this.searchTriggered = true; 
    },
    // downloadHandler() {
    //   this.search.action = 'download';
    //   this.pageChangeHandler(1);
    // },
    handlerBtnReject(item) {
      const obj = {
        owned_by: [item.owned_by],
        current_state: this.$route.params.status,
        user_id: null
      };
      this.$confirm('You reject this request. You can not undo this action. Continue?', 'Confirmation', {
        type: 'info',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await this.$store.dispatch(REJECT_AWA, {
              id: this.$route.params.id,
              // current_state: this.$route.params.status,
              data: obj,
            }).then(() => {
              this.$message({
                title: 'Success',
                type: 'success',
                message: 'Rejection success',
              });
              this.getList();
            }).catch((err) => {
              if (err.response?.data) popupErrorMessages(err.response.data);
            });
            instance.confirmButtonLoading = false;
          }
          done();
        },
      }).catch(() => {});
    },
    handlerBtnRollback(item) {
      const obj = {
        owned_by: item.owned_by,
        user_id : null,
        current_state: this.$route.params.status,
      };
      this.$confirm('You rollback this request. You can not undo this action. Continue?', 'Confirmation', {
        type: 'info',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await this.$store.dispatch(ROLLBACK_APPROVAL, {
              id: this.$route.params.id,
              // current_state: this.$route.params.status,
              data: obj,
            }).then(() => {
              this.$message({
                title: 'Success',
                type: 'success',
                message: 'Rollback Successful',
              });
              this.getList();
            }).catch((err) => {
              if (err.response?.data) popupErrorMessages(err.response.data);
            });
            instance.confirmButtonLoading = false;
          }
          done();
        },
      }).catch(() => {});
    },
    handlerApproveBtn(item, current_state) {
      this.show.modal_ewa = true;
      this.selected_ewa = item;
      // this.selected_ewa.action = current_state === 'WAITING_APPROVAL;' ? 'WAITING_DISBURSEMENT' : 'disburse';
      this.selected_ewa.action = current_state === 'WAITING_APPROVAL;' ? 'WAITING_DISBURSEMENT' : 'COMPLETED';
      this.selected_ewa.current_state = current_state;
      this.inquiry();
    },
     handlerApproveBtnn(item, current_state) {
      this.show.modal_ewa = true;
      this.selected_ewa = item;
      this.selected_ewa.action = current_state === 'WAITING_APPROVAL;' ? 'WAITING_DISBURSEMENT' : 'COMPLETED';
      this.selected_ewa.current_state = current_state;
      this.inquiryy();
    },
     async inquiryy() {
      this.loading.modal_ewa = true;
      const payload = {
        id: this.selected_ewa.company_id,
        data: {
          current_state: this.selected_ewa.current_state,
          approval_type: "batch",
          // bank_code: [this.form.bank_id],
          bank_code: this.form.bank_id,
          // bank_code: JSON.stringify(this.form.bank_id || null),
        },
      };
      try {
        const response = await this.$store.dispatch(INQUIRY_APPROVAL, payload);
        this.approval_id = response.data.approval_id;
        const result = response.data;
        this.disburse = {
          // approval_id: result.approval_id,
          total_amount: result.total_amount,
          total_admin_fee: result.total_admin_fee,
          auto_disburse: result.auto_disburse,
          total_disburse_amount: result.total_disburse_amount
        };
        this.selected_ewa.approval_id = result.approval_id;
        this.selected_ewa_bank = result;
      } catch (error) {
      } finally {
        this.loading.modal_ewa = false;
      }
    },
    async inquiry() {
      this.loading.modal_ewa = true;
      const payload = {
        id: this.selected_ewa.company_id,
        data: {
          current_state: this.selected_ewa.current_state,
          approval_type: "single",
          owned_by: this.selected_ewa.owned_by?.toString() || '',
          // bank_code: JSON.stringify(this.form.bank_id || null),
          // bank_code: ([this.form.bank_id && this.form.bank_id.length])
          // ? [this.form.bank_id.join(',')]   // 👉 "999,009"
          // : null,
           bank_code: this.form.bank_id
        },
      };
      try {
        const response = await this.$store.dispatch(INQUIRY_APPROVAL, payload);
        this.approval_id = response.data.approval_id;
        const result = response.data;
        this.disburse = {
          // approval_id: result.approval_id,
          total_amount: result.total_amount,
          total_admin_fee: result.total_admin_fee,
          auto_disburse: result.auto_disburse,
          total_disburse_amount: result.total_disburse_amount
        };
        this.selected_ewa.approval_id = result.approval_id;
        this.selected_ewa_bank = result;
      } catch (error) {
      } finally {
        this.loading.modal_ewa = false;
      }
    },
    async inquiry() {
      this.loading.modal_ewa = true;
      const payload = {
        id: this.selected_ewa.company_id,
        data: {
          current_state: this.selected_ewa.current_state,
          approval_type: "single",
          owned_by: this.selected_ewa.owned_by?.toString() || '',
          bank_code: this.form.bank_id
        },
      };
      try {
        const response = await this.$store.dispatch(INQUIRY_APPROVAL, payload);
        this.approval_id = response.data.approval_id;
        const result = response.data;
        this.disburse = {
          // approval_id: result.approval_id,
          total_amount: result.total_amount,
          total_admin_fee: result.total_admin_fee,
          auto_disburse: result.auto_disburse,
          total_disburse_amount: result.total_disburse_amount
        };
        this.selected_ewa.approval_id = result.approval_id;
        this.selected_ewa_bank = result;
      } catch (error) {
      } finally {
        this.loading.modal_ewa = false;
      }
    },
    async submit_approval() {
      this.$confirm(
        'You will approve this AWA disbursement. You can not undo this action. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;

              const payload = {
                id: this.selected_ewa.company_id,
                data: {
                  approval_id: this.approval_id,
                  owned_by: this.selected_ewa.owned_by?.toString() || null,
                  approval_type : "single",
                  // payment_confirm_file: "https://www.hollywoodreporter.com/wp-content/uploads/2012/12/img_logo_blue.jpg?w=2000&h=1126&crop=1"
                  payment_confirm_file: this.file_tmp
                },
              };
              try {
                const response = await this.$store.dispatch(SUBMIT_APPROVAL, payload);
                this.$message({
                  title: 'Success',
                  type: 'success',
                  message: 'Approval success',
                });

                this.show.modal_ewa = false;
                this.getList();
              } catch (err) {
                if (err.response?.data) popupErrorMessages(err.response.data);
              }
              instance.confirmButtonLoading = false;
            }
            done();
          },
        }
      ).catch(() => {});
    },
     async submit_approval_all() {
      this.$confirm(
        'You will approve this AWA disbursement. You can not undo this action. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;

              const payload = {
                id: this.selected_ewa.company_id,
                data: {
                  approval_id: this.approval_id,
                  approval_type : "batch",
                  payment_confirm_file: this.file_tmp,
                  bank_code: this.form.bank_id
                },
              };
              try {
                const response = await this.$store.dispatch(SUBMIT_APPROVAL, payload);
                this.$message({
                  title: 'Success',
                  type: 'success',
                  message: 'Approval success',
                });

                this.show.modal_ewa = false;
                this.getList();
              } catch (err) {
                if (err.response?.data) popupErrorMessages(err.response.data);
              }
              instance.confirmButtonLoading = false;
            }
            done();
          },
        }
      ).catch(() => {});
    },
  },
  watch: {
    'form.bank_id'(newVal, oldVal) {
      this.searchTriggered = false; 
    }
  }
};
</script>
<style>
.el-range-separator {
  width: 10% !important;
}
</style>